import { useEntity } from '@backstage/plugin-catalog-react';

import { slackLinks } from './utils';
import { SlackCard } from './SlackCard';

export const ServiceSlackCard = () => {
  const { entity } = useEntity();
  return <SlackCard links={slackLinks(entity)} />;
};
